<ng-container *ngIf="(surveyViewerService.activeSurvey$ | async).form.get(this.question.key)">
  <div id="matrixFormSmall" data-testId="checkboxMatrixFormSmall" *ngIf="isSmallScreen">
    <div *ngFor="let rowKey of question.rowsOrder" data-testId="matrixRowMobile">
      <img
           *ngIf="surveyViewerService.getRowLabelImageUrl(question, rowKey, activeLang) && question.useImage"
           src="{{surveyViewerService.getRowLabelImageUrl(question, rowKey, activeLang)}}"
           alt="image" class="image-label" [style.width]="question.imageSize+'px'"
      >

      <ng-container [formGroup]="$any(questionFormControl.get(rowKey).get(question.formControlName))">

        <div class="matrix-statement-title">{{question.rows[rowKey].label | translateLabel: activeLang}}</div>

        <div *ngFor="let sKey of isReversedStatements" data-testId="statementMobile">

          <ng-container>
            <mat-checkbox [color]="'primary'" class="vertical-matrix-selection selection-input"
                          (change)="question.applyMaxAnswers(surveyViewerService.activeSurvey$.value.form); question.resetOtherStatementsOnUniqueMentionStatementSelection(rowKey, sKey, questionFormControl)"
                          [formControl]="$any(questionFormControl.get(rowKey).get(question.formControlName).get(sKey))"
                          data-testId="matrixCheckboxMobile">
              <mat-label>
                <img
                  *ngIf="surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang) && question.useImage"
                  src="{{surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang)}}"
                  alt="image" class="image-label" [style.width]="question.imageSize+'px'"
                >
                {{question.statements[sKey].label | translateLabel: activeLang}}
              </mat-label>
            </mat-checkbox>
            <ng-container *ngIf="questionFormControl.get(rowKey).get(question.commentsControlName).get(sKey) && questionFormControl.get(rowKey).get(question.formControlName).get(sKey).value">
              <mat-form-field [color]="'primary'" appearance="outline" class="w-full selection-comment">
                <mat-label>{{'Expliquez votre choix'|transloco}}
                  ({{question.rows[rowKey].label | translateLabel: activeLang + ': ' + question.statements[sKey].label | translateLabel: activeLang}}
                  )
                </mat-label>
                <input appNoPaste [errorStateMatcher]="errorMatcher" type="text" matInput
                       [formControl]="$any(questionFormControl.get(rowKey).get(question.commentsControlName).get(sKey))"
                       (input)="onInput($event.target.value, sKey, rowKey)"
                       (blur)="onBlur($event.target.value.trim(), sKey, rowKey)">
                <mat-error>
                  {{'Le commentaire ne peut être vide'|transloco}}.
                </mat-error>
              </mat-form-field>
              <ng-container *ngIf="isValidAI?.[rowKey]?.[sKey]| async as isValidAI">
                <div class="warning-message mb-8" *ngIf="!isValidAI.isValid">**** {{isValidAI.explication}}</div>
              </ng-container>
            </ng-container>
            </ng-container>
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="surveyViewerService.allFormControlsMarkedAsTouched$.value && questionFormControl.errors">
      <mat-error *ngIf="questionFormControl.hasError(surveyViewerService.requireSelectionForEachStatementFnName)">
        {{'Une sélection doit être faite pour chaque ligne.'|transloco}}
      </mat-error>

      <mat-error *ngIf="questionFormControl.hasError(surveyViewerService.minRowErrorFnName)">
        {{surveyViewerService.errorMessages.minRowSelection(question.minAnswers.rows) | translateLabel: activeLang}}
      </mat-error>

      <mat-error *ngIf="questionFormControl.hasError(surveyViewerService.minStatementErrorFnName)">
        {{surveyViewerService.errorMessages.minStatementSelection(question.minAnswers.statements) | translateLabel: activeLang}}
      </mat-error>
    </ng-container>

  </div>

  <div *ngIf="!isSmallScreen" data-testId="checkboxMatrixForm">
    <div id="matrixFormBig">
      <div>
      </div>
      <ng-container *ngFor="let sKey of question.statementsOrder">
        <div data-testId="matrixCheckboxStatement" class="columnLabel">
          <img
            *ngIf="surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang) && question.useImage"
            src="{{surveyViewerService.getStatementLabelImageUrl(question, sKey, activeLang)}}"
            alt="image" [style.width]="question.imageSize+'px'"
            class="image-label"
          >
          <div>
            {{question.statements[sKey].label | translateLabel: activeLang}}
          </div>
        </div>
      </ng-container>
    </div>
    <div id="matrixFormBigRows">
      <div class="rowsContainer">
        <div *ngFor="let rowKey of question.rowsOrder" data-testId="matrixCheckboxRow" class="matrixRow">
          <div class="rowLabel">
            <img
              *ngIf="surveyViewerService.getRowLabelImageUrl(question, rowKey, activeLang) && question.useImage"
              src="{{surveyViewerService.getRowLabelImageUrl(question, rowKey, activeLang)}}"
              alt="image" [style.width]="question.imageSize+'px'"
              class="image-label"
            >
            {{question.rows[rowKey].label | translateLabel: activeLang}}
          </div>
          <div *ngFor="let sKey of question.statementsOrder" class="selectionContainer">
            <mat-checkbox [color]="'primary'" class="checkbox-button"
                          (change)="question.applyMaxAnswers(surveyViewerService.activeSurvey$.value.form); question.resetOtherStatementsOnUniqueMentionStatementSelection(rowKey, sKey, questionFormControl)"
                          [formControl]="$any(questionFormControl.get(rowKey).get(question.formControlName).get(sKey))"
                          data-testId="matrixCheckbox">
            </mat-checkbox>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="surveyViewerService.allFormControlsMarkedAsTouched$.value && questionFormControl.errors">
      <mat-error *ngIf="questionFormControl.hasError(surveyViewerService.requireSelectionForEachStatementFnName)">
        {{'Une sélection doit être faite pour chaque ligne.'|transloco}}
      </mat-error>

      <mat-error *ngIf="questionFormControl.hasError(surveyViewerService.minRowErrorFnName)">
        {{surveyViewerService.errorMessages.minRowSelection(question.minAnswers.rows) | translateLabel: activeLang}}
      </mat-error>

      <mat-error *ngIf="questionFormControl.hasError(surveyViewerService.minStatementErrorFnName)">
        {{surveyViewerService.errorMessages.minStatementSelection(question.minAnswers.statements) | translateLabel: activeLang}}
      </mat-error>
    </ng-container>

    <ng-container *ngFor="let rKey of question.rowsOrder">
      <ng-container *ngFor="let sKey of question.statementsOrder">
        <ng-container *ngIf="questionFormControl.get(rKey).get(question.commentsControlName).get(sKey) && questionFormControl.get(rKey).get(question.formControlName).get(sKey).value">
          <mat-form-field [color]="'primary'" appearance="outline" class="w-full">
            <mat-label>{{'Expliquez votre choix'|transloco}}
              ({{(question.rows[rKey].label | translateLabel: activeLang) + ': ' + (question.statements[sKey].label | translateLabel: activeLang)}}
              )
            </mat-label>
            <input appNoPaste [errorStateMatcher]="errorMatcher" type="text" matInput
                   [formControl]="$any(questionFormControl.get(rKey).get(question.commentsControlName).get(sKey))"
                   (input)="onInput($event.target.value, sKey, rKey)"
                   (blur)="onBlur($event.target.value.trim(), sKey, rKey)">
            <mat-error>
              {{'Le commentaire ne peut être vide'|transloco}}.
            </mat-error>
          </mat-form-field>
          <ng-container *ngIf="isValidAI?.[rKey]?.[sKey]| async as isValidAI">
            <div class="warning-message mb-8" *ngIf="!isValidAI.isValid">**** {{isValidAI.explication}}</div>
          </ng-container>
        </ng-container>

      </ng-container>
    </ng-container>

  </div>
</ng-container>
